// FETCH ALL FEEDBACK
export const FETCH_FEEDBACK_MASTER_REQUEST = 'FETCH_FEEDBACK_MASTER_REQUEST';
export const FETCH_FEEDBACK_MASTER_SUCCESS = 'FETCH_FEEDBACK_MASTER_SUCCESS';
export const FETCH_FEEDBACK_MASTER_FAILURE = 'FETCH_FEEDBACK_MASTER_FAILURE';

// CREATE FEEDBACK
export const CREATE_FEEDBACK_MASTER_REQUEST = 'CREATE_FEEDBACK_MASTER_REQUEST';
export const CREATE_FEEDBACK_MASTER_SUCCESS = 'CREATE_FEEDBACK_MASTER_SUCCESS';
export const CREATE_FEEDBACK_MASTER_FAILURE = 'CREATE_FEEDBACK_MASTER_FAILURE';

// UPDATE FEEDBACK
export const UPDATE_FEEDBACK_MASTER_REQUEST = 'UPDATE_FEEDBACK_MASTER_REQUEST';
export const UPDATE_FEEDBACK_MASTER_SUCCESS = 'UPDATE_FEEDBACK_MASTER_SUCCESS';
export const UPDATE_FEEDBACK_MASTER_FAILURE = 'UPDATE_FEEDBACK_MASTER_FAILURE';

// FETCH SINGLE STATE OF FEEDBACK
export const FETCH_SINGLE_FEEDBACK_MASTER_REQUEST = 'FETCH_SINGLE_FEEDBACK_MASTER_REQUEST';
export const FETCH_SINGLE_FEEDBACK_MASTER_SUCCESS = 'FETCH_SINGLE_FEEDBACK_MASTER_SUCCESS';
export const FETCH_SINGLE_FEEDBACK_MASTER_FAILURE = 'FETCH_SINGLE_FEEDBACK_MASTER_FAILURE';

// DELETE FEEDBACK
export const DELETE_FEEDBACK_MASTER_REQUEST = 'DELETE_FEEDBACK_MASTER_REQUEST';
export const DELETE_FEEDBACK_MASTER_SUCCESS = 'DELETE_FEEDBACK_MASTER_SUCCESS';
export const DELETE_FEEDBACK_MASTER_FAILURE = 'DELETE_FEEDBACK_MASTER_FAILURE';

export const RESET_FEEDBACK_MASTER_INFO = 'RESET_FEEDBACK_MASTER_INFO';

export const CREATE_FEEDBACK_MASTER_FORM = 'CREATE_FEEDBACK_MASTER_FORM';

export const UPDATE_FEEDBACK_MASTER_FORM = 'UPDATE_FEEDBACK_MASTER_FORM';

// NAVIGATE TO FEEDBACK DETAILS COMPONENT
export const NAVIGATE_FEEDBACK_DETAILS = 'NAVIGATE_FEEDBACK_DETAILS';

// NAVIGATE TO FEEDBACK COMPONENT
export const NAVIGATE_FEEDBACK_MASTER = 'NAVIGATE_FEEDBACK_MASTER';
